<template>
  <article class="intro-wrapper">
    <video muted autoplay loop>
      <source
        src="https://kr.object.ncloudstorage.com/newglobal/main/main/bg-video-0116.mp4"
        type="video/mp4"
      />
    </video>
    <div class="text-wrapper">
      <p class="title">WE SERVE<br />GLOBAL SUCCESS</p>
      <p class="sub">
        서로에게서 최고의 것을 발견하고, 최고의 것을 주는 사람들.<br />우리는
        CARROT 입니다.
      </p>
    </div>
  </article>
</template>
<script>
export default {
  mounted() {
    // header color change
    const mainHeader = document.querySelector(".header");
    const introWrapper = document.querySelector(".intro-wrapper").offsetHeight;

    window.addEventListener("scroll", function () {
      if (window.scrollY >= introWrapper) {
        mainHeader.classList.add("active");
      } else {
        mainHeader.classList.remove("active");
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.intro-wrapper {
  position: relative;
  height: 100vh;
  // background: url(~@/assets/img/newGlobal/main/intro/bg.jpg) no-repeat 50% 20% /
  //   cover;
  overflow: hidden;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .text-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    padding: 0 20px;
    transform: translate(-50%, -50%);
    color: #ffffff;
    text-align: center;

    .title {
      font-size: 50px;
      font-weight: bold;
      line-height: 1.2;
      text-shadow: 0px 0px 15px rgb(0 0 0 / 38%);
      margin-bottom: 25px;
    }

    .sub {
      font-size: 17px;
    }
  }
}

@media screen and (min-width: 799px) {
  .intro-wrapper {
    .text-wrapper {
      .title {
        font-size: 100px;
      }
    }
  }
}

@media screen and (min-width: 1350px) {
  .intro-wrapper {
    .text-wrapper {
      .sub {
        font-size: 23px;
      }
    }
  }
}
</style>
